import axiosInstance from "../interceptor";
import { ApiEndpoints } from "../../constants/api/auth.api";

export const authAPI = {
    createAccount: (data) => {
        return axiosInstance.post(ApiEndpoints.createAccount.url,data);
    },
    sendLoginOTP: (data) => {
        return axiosInstance.post(ApiEndpoints.sendLoginOTP.url,data);
    },
    verifyAccount: (data) => {
        return axiosInstance.put(ApiEndpoints.verifyAccount.url,data);
    },
    verifyLoginOTP: (data) => {
        return axiosInstance.post(ApiEndpoints.verifyLoginOTP.url,data);
    },
    accessToken: (data) => {
        return axiosInstance.get(ApiEndpoints.accessToken.url,data);
    },
};